export class TextMessage {
    public to: string;
    public message: string;
}